module.exports = "pegasus/assets/tech/medium/2.jpg";